export default __webpack_public_path__ + "static/media/skate_shadow@3x.57ee430b.png";